<template>
  <wo-card v-if="credentials" :title="$t('admin.user.credentials.title')">
    <po-action-dropdown slot="actions" :actions="actions" @execute="execute" mod-right />
    <wo-properties v-if="hasCredentials" mod-bordered>
      <template v-for="credential in credentials">
      <wo-properties-label :key="credential.id"><wo-label>{{ credential.type.id }}</wo-label></wo-properties-label>
      <wo-properties-value :key="credential.id + '-'">
        <div>
          <span v-t="'admin.user.credentials.createdOn'"></span>: {{ credential.created_on | date }}
        </div>
        <div v-if="credential.reset_requested_on">
          <span v-t="'admin.user.credentials.resetRequestedOn'"></span>: {{ credential.reset_requested_on | date }}
        </div>
      </wo-properties-value>
      </template>
    </wo-properties>
    <po-empty-state v-else label-key="admin.user.credentials.empty" />
  </wo-card>
</template>

<script>

import _ from 'lodash'

import { UserCredentialTypeEnum, User } from '@/model/identity'

import { showInformation } from '@/modal'

import { credentialsResetRepository, apiKeyRepository } from '@/repository/identity'

const resetAction = { id: 'reset-password', labelKey: 'admin.user.action.resetPassword', icon: 'loop' }
const createApiKeyAction = { id: 'create-api-key', labelKey: 'admin.user.action.createApiKey', icon: 'gear' }

export default {
  props: {
    credentials: Array,
    user: User
  },
  computed: {
    hasCredentials () {
      return this.credentials && !_.isEmpty(this.credentials)
    },
    actions () {
      const result = []
      if (this.getCredentialOfType(UserCredentialTypeEnum.values.PASSWORD)) {
        result.push(resetAction)
      }
      if (!this.getCredentialOfType(UserCredentialTypeEnum.values.API_KEY)) {
        result.push(createApiKeyAction)
      }
      return result
    }
  },
  methods: {
    getCredentialOfType (type) {
      return _.find(this.credentials, t => t.type === type)
    },
    execute (action) {
      switch (action) {
        case resetAction:
          this.resetPassword()
          break
        case createApiKeyAction:
          this.createApiKey()
          break
      }
    },
    resetPassword () {
      this.$store.dispatch(credentialsResetRepository.create, { entity: { email: this.user.email } })
        .then(this.emitUpdate)
    },
    emitUpdate () {
      this.$emit('update')
    },
    createApiKey () {
      this.$store.dispatch(apiKeyRepository.create, { userId: this.user.id })
        .then(this.showToken)
    },
    showToken (key) {
      showInformation({ message: key.token })
        .then(this.emitUpdate)
    }
  }
}
</script>
